export const INPUT_TYPES = {
    LEFT: "LEFT",
    RIGHT: "RIGHT",
    UP: "UP",
    DOWN: "DOWN",
    JUMP: "JUMP"
}